export const getBaseURL = () => {
  // Runtime env (Docker) dan olish — birinchi ustuvorlik
  if (window.__ENV__ && window.__ENV__.API_URL) {
    return window.__ENV__.API_URL;
  }
  // Fallback: build vaqtidagi .env dan
  return process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PRODUCTION_BASE_URL
    : process.env.REACT_APP_DEVELOPMENT_BASE_URL;
};
